/*
graph: processedGraph, value2, {..., nodes: [], properties:[], relations:[tags and normal relations]}
path:
- findNodeId(graph, path) -> nodeId (a path alapján megtalálja a nodeId-t,
  a path szerkezetét még kitalálom, mert akár bármilyen más, nem uploaded fájlokban lévő node-ok megtalálására is praktikus
  lenne egy ilyen)
- generateId(graph, path) -> nodeId
- newFolder(graph, name) -> nodeId (üresen, nem bekötve sehova)
- newFile(graph, data) -> nodeId (üresen, nem bekötve sehova)
- firstLink(graph, parentNodeId, childNodeId) -> newChildNodeId - első bekötés, childNodeId-nak nem lehet relationje
- secondLink(graph, parentNodeId, childNodeId) -> newChildNodeId - további bekötések, vizsgálnia kell, hogy nem keletkezik-e irányított kör, mert ha keletkezik, akkor a rekurzív műveletek elszabadulhatnak, végtelen ciklusba kerülhetnek,...
- deleteSingle(graph, nodeId) -> void - fájlt vagy üres foldert töröl
- deleteRecursive(graph, nodeId) -> string[] - minden fájlt és könyvtárat töröl rekurzívan bejárva, visszaadja a törölt fájlok tömbjét (hogy ténylegesen is ki lehessen töröltetni a StorJ-vel)
- getAllFolders(graph, pathstring) -> string[] - az összes path, ami a gyereke teljes elérési úttal
*/
import { makeFolderName, splitPath, removeFirstPathElement } from "../paths";
import { ensureAuxStructures2, recreateAuxStructures2 } from "./graphauxcreator2";
import { findFileSystemRoot2 } from "./graphstorage2";
import { guessMimeType } from "../mimetype";
export const CATEGORY_ROOT_NODE_TYPE = "dwin://schema/graph/category_layer/node/root";
export const CATEGORY_NODE_TYPE = "dwin://schema/graph/category_layer/node/category";
export const FILESYSTEM_ROOT_NODE_TYPE = "dwin://schema/graph/filesystem_layer/node/root";
export const FILESYSTEM_FILE_NODE_TYPE = "dwin://schema/graph/filesystem_layer/node/file";
export const FILESYSTEM_FOLDER_NODE_TYPE = "dwin://schema/graph/filesystem_layer/node/folder";
export const META_FILE_NODE_TYPE = "dwin://schema/graph/meta_layer/node/file";
export const BRIDGE_LINK_EDGE_TYPE = "dwin://schema/graph/bridge_layer/edge/link";
export const CATEGORY_CONTAINS_EDGE_TYPE = "dwin://schema/graph/category_layer/edge/contains";
export const FILESYSTEM_CONTAINS_EDGE_TYPE = "dwin://schema/graph/filesystem_layer/edge/contains";
export const META_LINK_EDGE_TYPE = "dwin://schema/graph/meta_layer/edge/metalink";
export const TYPE_ROOT2 = "dwin://schema/graph/filesystem_layer/node/root";
export const TYPE_FOLDER2 = "dwin://schema/graph/filesystem_layer/node/folder";
export const TYPE_FILE2 = "dwin://schema/graph/filesystem_layer/node/file";
export const TYPE_PROPERTY_FILENAME = "dwin://prop/filesystem/fileName";
export const RELATION_FILE_FOLDER2 = "dwin://schema/graph/filesystem_layer/edge/contains";
export const RELATION_CATEGORY2 = "dwin://schema/graph/category_layer/edge/contains";
export const RELATION_META2 = "dwin://schema/graph/meta_layer/edge/link";
export const RELATION_BRIDGE_LINK = "dwin://schema/graph/bridge_layer/edge/link";
//export const GROUP_FULL = "a";
//export const GROUP_EMPTY = "b";
export const GROUP_FULL = "a";
export const GROUP_EMPTY = "b";
const CID_FILESYSTEM = 9;
const CATEGORY_ROOT = "dwin://schema/graph/category_layer/node/root";
export const LAYER_CATEGORY = "category";
export const LAYER_FILESYSTEM = "filesystem";
export const LAYER_META = "meta";
export function overwriteProcessedGraph(target, source) {
    target.nodes = JSON.parse(JSON.stringify(source.nodes));
    target.edges = JSON.parse(JSON.stringify(source.edges));
    target.graphInfo = JSON.parse(JSON.stringify(source.graphInfo));
    ensureAuxStructures2(target);
}
export function copyProcessedGraph(processedGraph) {
    const copy = JSON.parse(JSON.stringify(processedGraph));
    ensureAuxStructures2(copy);
    return copy;
}
// OK
export function getAllFoldersWithIds2(processedGraph, pathString, nodeId) {
    ensureAuxStructures2(processedGraph);
    if (pathString.startsWith("/dataOwnerFiles")) {
        const firstElementRemovedFullPath = removeFirstPathElement(pathString);
        if (firstElementRemovedFullPath === undefined) {
            return [];
        }
        pathString = firstElementRemovedFullPath;
    }
    //console.log("pathString", pathString);
    let folderNodeId;
    if (nodeId !== undefined) {
        folderNodeId = nodeId;
    }
    else {
        const fileSystemRoot = findFileSystemRoot2(processedGraph);
        //console.log("fileSystemRoot", fileSystemRoot);
        if (fileSystemRoot === undefined) {
            return [];
        }
        folderNodeId = findNodeId2(processedGraph, pathString, fileSystemRoot.id);
        //console.log("folderNodeId", folderNodeId);
        if (folderNodeId === undefined) {
            return [];
        }
    }
    const ret = new Map();
    if (pathString !== "") {
        ret.set(pathString, folderNodeId);
    }
    //const childNodes = findChildrenOfNodeById(processedGraph, folderNodeId, [RELATION_FILE_FOLDER, RELATION_HAS]);
    const childNodes = findChildrenOfNodeById2(processedGraph, folderNodeId);
    //console.log("childNodes", childNodes);
    const folderChildNodes = childNodes.filter((node) => node._type === TYPE_FOLDER2);
    //console.log("folderChildNodes", folderChildNodes);
    for (const childNode of folderChildNodes) {
        const nextPath = makeFolderName(pathString, childNode.label?.toString() ?? "");
        //console.log("nextPath", nextPath);
        if (nextPath !== "") {
            const allPaths = getAllFoldersWithIds2(processedGraph, nextPath, childNode.id);
            //console.log("allPaths", allPaths);
            const slashStrippedAllPaths = allPaths.map((elem) => elem.path.endsWith("/") ? { path: elem.path.slice(0, -1), id: elem.id } : { path: elem.path, id: elem.id });
            for (const elem of slashStrippedAllPaths) {
                ret.set(elem.path, elem.id);
            }
        }
    }
    const retArray = Array.from(ret, ([path, id]) => ({ path, id }));
    //console.log("ret", retArray);
    return retArray;
}
// OK
export function getAllFolders2(processedGraph, pathString, nodeId) {
    const foldersWithIds = getAllFoldersWithIds2(processedGraph, pathString, nodeId);
    return Array.from(foldersWithIds.map(({ path, id }) => path));
}
// OK
export function findNodeId2(processedGraph, pathString, rootNodeId) {
    ensureAuxStructures2(processedGraph);
    //console.log(processedGraph);
    if (pathString === undefined ||
        processedGraph?.nodes === undefined ||
        processedGraph?.edges === undefined ||
        processedGraph?.nodes.length === 0) {
        return undefined;
    }
    let rootNode;
    if (rootNodeId !== undefined) {
        rootNode = processedGraph.aux?.getNodeById(rootNodeId);
    }
    if (rootNode === undefined) {
        rootNode = findRootNode2(processedGraph);
    }
    //console.log(rootNode);
    if (pathString === "/") {
        return rootNode.id;
    }
    let currentNode = rootNode;
    const pathParts = splitPath(pathString);
    const path = pathParts?.parts ?? [];
    //console.log(path);
    let pathIndex = 0;
    while (pathIndex < path.length) {
        const currentNodeOutRelations = processedGraph.aux?.getEdgesByFrom(currentNode.id) ?? [];
        let found = false;
        for (const outRelation of currentNodeOutRelations) {
            const targetNode = processedGraph.aux?.getNodeById?.(outRelation.to);
            if (targetNode === undefined) {
                continue;
            }
            /*console.log(
              outRelation,
              JSON.stringify(targetNode),
              path[pathIndex],
              targetNode?.properties?.fileName,
              targetNode?.properties?.fileName === path[pathIndex],
            );*/
            if (targetNode?.label === path[pathIndex] ||
                getFileNameProperty2(processedGraph, targetNode) === path[pathIndex]) {
                //console.log("found", targetNode);
                found = true;
                currentNode = targetNode;
                pathIndex++;
                break;
            }
        }
        if (!found) {
            return undefined;
        }
    }
    return currentNode.id;
}
// OK
function getFileNameProperty2(processedGraph, node) {
    return node?.label;
}
// OK
export function findChildrenOfNodeById2(processedGraph, parentId, allowedRelationTypes, disallowedRelationTypes, bothDirections) {
    ensureAuxStructures2(processedGraph);
    let childrenRelations = processedGraph.aux?.getEdgesByFrom(parentId) ?? [];
    if (bothDirections === true) {
        const backRelations = processedGraph.aux?.getEdgesByTo(parentId) ?? [];
        childrenRelations.push(...backRelations);
    }
    //console.log("findChildrenOfNodeById", "childrenRelations", childrenRelations);
    if (allowedRelationTypes !== undefined) {
        childrenRelations = childrenRelations.filter((relation) => allowedRelationTypes.includes(relation._type));
    }
    if (disallowedRelationTypes !== undefined) {
        childrenRelations = childrenRelations.filter((relation) => !disallowedRelationTypes.includes(relation._type));
    }
    //console.log("findChildrenOfNodeById", "childrenRelations filtered by relation type", childrenRelations);
    let childNodes;
    if (bothDirections === true) {
        childNodes = childrenRelations.map((childRelation) => {
            if (childRelation.to === parentId) {
                return processedGraph.aux?.getNodeById(childRelation.from);
            }
            if (childRelation.from === parentId) {
                return processedGraph.aux?.getNodeById(childRelation.to);
            }
            return undefined;
        });
    }
    else {
        childNodes = childrenRelations.map((childRelation) => processedGraph.aux?.getNodeById(childRelation.to));
    }
    //console.log("findChildrenOfNodeById", "childNodes", childNodes);
    const childNodesWithoutUndefinedAndParent = childNodes
        .filter((element) => element !== undefined && element.id !== parentId)
        .filter((element) => element !== undefined);
    //console.log("findChildrenOfNodeById", "returned", childNodesWithoutUndefinedAndParent);
    return childNodesWithoutUndefinedAndParent;
}
// OK
export function generateNewFolderId2(processedGraph) {
    return generateNewId2(processedGraph);
}
// OK
export function generateNewFileId2(processedGraph) {
    return generateNewId2(processedGraph);
}
// OK
function generateNewId2(processedGraph, excludedIds) {
    const maxIdNumber = getMaxIdNumber2(processedGraph.nodes.map((node) => node.id), excludedIds);
    const newIdNumber = maxIdNumber + 1;
    return newIdNumber;
}
// OK
function getMaxIdNumber2(numbers, excludedIds) {
    const fullNumberList = [...numbers];
    if (excludedIds !== undefined) {
        fullNumberList.push(...excludedIds);
    }
    let maxIdNumber = 0;
    for (const idNumber of fullNumberList) {
        if (idNumber > maxIdNumber) {
            maxIdNumber = idNumber;
        }
    }
    return maxIdNumber;
}
// OK
export function mkdirs2(processedGraph, parentFolderId, newFolderPath) {
    ensureAuxStructures2(processedGraph);
    const newFolderId = findNodeId2(processedGraph, newFolderPath, parentFolderId);
    if (newFolderId !== undefined) {
        return newFolderId;
    }
    const folderPathParts = splitPath(newFolderPath);
    let currentFolderId = parentFolderId;
    for (const pathPart of folderPathParts?.parts ?? []) {
        let childFolderId = findNodeId2(processedGraph, pathPart, currentFolderId);
        if (childFolderId === undefined) {
            // TODO create folder --> childFolderId !== undefined
            const firstFolderId = newFolder2(processedGraph, pathPart);
            childFolderId = firstLink2(processedGraph, currentFolderId, firstFolderId);
        }
        currentFolderId = childFolderId;
    }
    recreateAuxStructures2(processedGraph);
    return currentFolderId;
}
// OK
export function newFolder2(processedGraph, name) {
    ensureAuxStructures2(processedGraph);
    const newFolder = {
        _created: makeCreatedFieldValue(),
        _type: TYPE_FOLDER2,
        cid: CID_FILESYSTEM,
        id: generateNewFolderId2(processedGraph),
        label: name,
        layer: LAYER_FILESYSTEM,
        level: 1, // to be determined when join
        readonly: false,
        uploadAllowed: true,
        childrenCount: 0,
        title: name,
    };
    processedGraph.nodes.push(newFolder);
    //  if (processedGraph.aux?.idToNodeMap !== undefined) {
    //    processedGraph.aux.idToNodeMap[newFolder.id] = newFolder;
    //  }
    recreateAuxStructures2(processedGraph);
    return newFolder.id;
}
// OK
export function newFile2(processedGraph, fileName, fileSize, fileMimeType, fileStorageId, creationTime) {
    ensureAuxStructures2(processedGraph);
    const newFileId = generateNewFileId2(processedGraph);
    const milliSecondsCreationTime = creationTime > 100_000_000_000 ? creationTime : creationTime * 1000;
    const date = new Date(milliSecondsCreationTime);
    const creationTimeFormatted = date.toISOString().replace(/\.\d{3}Z$/, "+00:00");
    const newFileNode = {
        _created: creationTimeFormatted,
        _type: TYPE_FILE2,
        cid: CID_FILESYSTEM,
        id: newFileId,
        label: fileName,
        layer: LAYER_FILESYSTEM,
        level: 1,
        readonly: false,
        uploadAllowed: true,
        size: fileSize,
        storagePath: fileStorageId,
        properties: {
            createdAt: milliSecondsCreationTime / 1000,
            fileName: fileName,
            fileSize: fileSize,
            fileMimeType: fileMimeType,
            fileStorageId: fileStorageId,
        },
    };
    processedGraph.nodes.push(newFileNode);
    recreateAuxStructures2(processedGraph);
    return newFileId;
}
// OK
export function firstLink2(processedGraph, parentNodeId, oldChildNodeId) {
    ensureAuxStructures2(processedGraph);
    const parent = processedGraph.aux?.getNodeById(parentNodeId);
    const child = processedGraph.aux?.getNodeById(oldChildNodeId);
    if (parent == undefined) {
        throw new Error("parent does not exist");
    }
    if (child == undefined) {
        throw new Error("child does not exist");
    }
    if ((processedGraph.aux?.getEdgesByTo(oldChildNodeId) ?? []).length > 0) {
        throw new Error("already has a relation pointing to child");
    }
    const parentsChildren = processedGraph.aux?.getEdgesByFrom(parentNodeId) ?? [];
    /*const childrenNodes = parentsChildren
      .map((rel) => rel.to)
      .map((id) => processedGraph.aux?.getNodeById(id))
      .filter((node) => node !== undefined);*/
    // We do not have to change id
    //const newChildNodeId = generateNewId2(processedGraph);
    //child.id = newChildNodeId;
    //let newRelP;
    const newRelation = {
        _created: makeCreatedFieldValue(),
        _type: RELATION_FILE_FOLDER2,
        from: parentNodeId,
        layer: LAYER_FILESYSTEM,
        readonly: false,
        to: oldChildNodeId,
    };
    processedGraph.edges.push(newRelation);
    child.level = parent.level + 1;
    let empty;
    if (child._type === TYPE_FOLDER2) {
        empty = true;
    }
    else if (child._type === TYPE_FILE2) {
        empty = false;
    }
    child.group = child.cid + "" + child.level + (empty ? GROUP_EMPTY : GROUP_FULL);
    //console.log(child.label + " (" + parent.label + ") group=" + child.group);
    recreateAuxStructures2(processedGraph);
    increaseChildrenCountTowardsTheRoot(processedGraph, child);
    // file properies will not be stored like this any more
    /*if (child._type === TYPE_FILE2) {
      // we have 4 properties as well
      const fileProperties = processedGraph.aux?.getPropertiesByS(oldChildNodeId) ?? [];
      const newPropIds = generateNewIds2(processedGraph, fileProperties.length);
      for (let i = 0; i < fileProperties.length; i++) {
        const propNode = processedGraph.aux?.getNodeById(fileProperties[i].o);
        fileProperties[i].s = newChildNodeId;
        fileProperties[i].o = newPropIds[i];
        if (propNode) {
          propNode.id = newPropIds[i];
        }
      }
    }*/
    return oldChildNodeId;
}
// OK
function increaseChildrenCountTowardsTheRoot(processedGraph, childNode) {
    // calculation for childNode is done
    ensureAuxStructures2(processedGraph);
    const edges = processedGraph.aux?.getEdgesByTo(childNode.id) ?? [];
    for (const edge of edges) {
        const parentNode = processedGraph.aux?.getNodeById(edge.from);
        if (parentNode) {
            parentNode.childrenCount = (parentNode?.childrenCount ?? 0) + 1;
            parentNode.group = parentNode.cid + "" + parentNode.level + GROUP_FULL;
            increaseChildrenCountTowardsTheRoot(processedGraph, parentNode);
        }
    }
}
function isLeaf(processedGraph, node) {
    const childNodes = findChildrenOfNodeById2(processedGraph, node.id, [RELATION_FILE_FOLDER2, RELATION_CATEGORY2, RELATION_META2], undefined, false);
    return childNodes.length === 0;
}
export function calculateChildrenCount(processedGraph) {
    ensureAuxStructures2(processedGraph);
    for (const node of processedGraph.nodes) {
        node.childrenCount = 0;
        if (isLeaf(processedGraph, node)) {
            let startCount = false;
            if (node.layer !== LAYER_CATEGORY) {
                startCount = true;
            }
            else {
                const edgesTo = processedGraph.aux?.getEdgesByTo(node.id) ?? [];
                const metaEdgesTo = edgesTo.filter((e) => e._type === RELATION_META2 || e._type === RELATION_BRIDGE_LINK);
                if (metaEdgesTo.length) {
                    startCount = true;
                }
            }
            if (startCount) {
                increaseChildrenCountTowardsTheRoot(processedGraph, node);
            }
        }
    }
}
// OK
export function linkTag2(processedGraph, nodeId, topLevelCategoryName) {
    ensureAuxStructures2(processedGraph);
    const node = processedGraph.aux?.getNodeById(nodeId);
    if (node === undefined) {
        throw new Error(`node (${nodeId}) is not found`);
    }
    if (topLevelCategoryName === "User Files") {
        throw new Error("Cannot create tag to User Files");
    }
    const topLevelCategoryNode = findTopLevelCategory2(processedGraph, topLevelCategoryName);
    const existingOutRelations = processedGraph.aux?.getEdgesByFrom(nodeId);
    if (existingOutRelations?.find((rel) => rel._type === RELATION_BRIDGE_LINK && rel.to === topLevelCategoryNode.id) !==
        undefined) {
        throw new Error(`Node (${nodeId}) already has tag (${topLevelCategoryName})`);
    }
    const tagRelation = {
        _created: makeCreatedFieldValue(),
        layer: "bridge",
        from: topLevelCategoryNode.id,
        _type: RELATION_BRIDGE_LINK,
        to: nodeId,
        readonly: false,
    };
    processedGraph.edges.push(tagRelation);
    recreateAuxStructures2(processedGraph);
}
// OK
function findTopLevelCategory2(processedGraph, topLevelCategoryName) {
    const rootNode = findRootNode2(processedGraph);
    const topLevelCategories = findChildrenOfNodeById2(processedGraph, rootNode.id);
    const topLevelCategoryNode = topLevelCategories.find((cat) => cat.label === topLevelCategoryName);
    if (topLevelCategoryNode === undefined) {
        throw new Error(`top level category (${topLevelCategoryName} is not found`);
    }
    return topLevelCategoryNode;
}
// OK
export function findRootNode2(processedGraph) {
    if (processedGraph?.nodes === undefined || processedGraph?.nodes.length === 0) {
        throw new Error("processedGraph or nodes list is undefined");
    }
    const rootNode = processedGraph.nodes.find((node) => node._type === CATEGORY_ROOT);
    if (rootNode === undefined) {
        throw new Error("no root node found");
    }
    return rootNode;
}
// OK
export function deleteSingle2(processedGraph, nodeId) {
    ensureAuxStructures2(processedGraph);
    // it deletes file or empty folder
    // is it folder and empty? (no downward relations exist)
    const node = processedGraph.aux?.getNodeById(nodeId);
    if (node?._type === TYPE_FOLDER2) {
        const downRelations = processedGraph.aux?.getEdgesByFrom(nodeId);
        if (downRelations?.length && downRelations.filter((rel) => rel._type !== RELATION_META2).length > 0) {
            throw new Error("folder is not empty");
        }
    }
    const inwardRelationsToDelete = processedGraph.aux?.getEdgesByTo(nodeId);
    const outwardRelationsToDelete = processedGraph.aux?.getEdgesByFrom(nodeId);
    const nodesToDelete = [node];
    //console.log("save after delete 1: delete nodes", nodesToDelete);
    //console.log("save after delete 1: in edges", inwardRelationsToDelete);
    //console.log("save after delete 1: out edges", outwardRelationsToDelete);
    // TODO: folytatni innen
    //console.log("deleteSingle", "nodeId", nodeId);
    //console.log("deleteSingle", "nodes", nodesToDelete);
    deleteNodes2(processedGraph, nodesToDelete);
    //console.log("deleteSingle", "inward relations", inwardRelationsToDelete);
    deleteRelations2(processedGraph, inwardRelationsToDelete ?? []);
    //console.log("deleteSingle", "outward relations", outwardRelationsToDelete);
    deleteRelations2(processedGraph, outwardRelationsToDelete ?? []);
    //console.log("deleteSingle", "properties", propertiesToDelete);
    //deleteProperties2(processedGraph, propertiesToDelete ?? []);
    recreateAuxStructures2(processedGraph);
}
// OK
function deleteNodes2(processedGraph, nodes) {
    for (const node of nodes) {
        if (node !== undefined) {
            deleteNode2(processedGraph, node);
        }
    }
}
// OK
function deleteNode2(processedGraph, node) {
    let index = -1;
    for (let i = 0; i < processedGraph.nodes.length; i++) {
        const currentNode = processedGraph.nodes[i];
        if (node.id === currentNode.id) {
            index = i;
        }
    }
    if (index !== -1) {
        processedGraph.nodes.splice(index, 1);
    }
}
// OK
function deleteRelations2(processedGraph, relations) {
    for (const relation of relations) {
        if (relation !== undefined) {
            deleteRelation2(processedGraph, relation);
        }
    }
}
// OK
function deleteRelation2(processedGraph, relation) {
    let index = -1;
    for (let i = 0; i < processedGraph.edges.length; i++) {
        const currentRelation = processedGraph.edges[i];
        if (relation.from === currentRelation.from &&
            relation._type === currentRelation._type &&
            relation.to === currentRelation.to) {
            index = i;
        }
    }
    if (index !== -1) {
        processedGraph.edges.splice(index, 1);
    }
}
// OK
function makeCreatedFieldValue() {
    const now = new Date(); // Current date and time
    const formattedDate = now.toISOString().replace(/\.\d{3}Z$/, "+00:00");
    return formattedDate;
}
// OK
export function addProperties2(node) {
    if (node._type === TYPE_FILE2) {
        node.properties = {
            createdAt: toEpochMillis(node._created) / 1000,
            fileName: node.label,
            fileSize: node.size ?? 0,
            fileMimeType: guessMimeType(node.storagePath ?? "") ?? "",
            fileStorageId: node.storagePath ?? "N/A",
        };
    }
}
function toEpochMillis(dateString) {
    const normalizedDateString = dateString.replace(/\.\d+$/, "");
    const date = new Date(normalizedDateString);
    return date.getTime();
}
